import _ from "lodash";

import api from "@/api/cloud";
import { set } from "@/utils/vuex";
import { createCommunity } from "../model/community";

const getInitState = () => ({
	items: [],
});

export default {
	namespaced: true,

	state: getInitState(),

	getters: {
		items: state => {
			return _.map(state.items, createCommunity);
		},

		itemByIdentifier: (state, getters) => identifier => {
			if (_.isNil(identifier)) return null;
			if (!_.isString(identifier)) identifier = "" + identifier;
			return _.find(getters.items, { identifier });
		},

		itemById: (state, getters) => id => {
			return _.find(getters.items, (item)=>{
				return item.id == id || item.legacyId == id;
			});
		},
	},

	mutations: {
		setCommunities: set("items"),

		resetState(state) {
			Object.assign(state, getInitState());
		},
	},

	actions: {
		async load({ state, commit }) {
			// Only load communities once.
			if (state.items.length) return;

			this._vm.$log(`Communities: Load communities`);

			try {
				const communities = await api.getCommunities();
				commit("setCommunities", communities);
			} catch (e) {
				commit("setCommunities", []);
				throw e;
			}
		},
	},
};
